import { useMutation } from 'react-query';

import { PauseSubscriptionResponse, pauseSubscription } from '@utils/backend-api/pauseSubscription';

export default function usePauseSubscription() {
  const { mutate, mutateAsync, isLoading, isError } = useMutation(() => pauseSubscription(), {
    onSuccess: (data: PauseSubscriptionResponse) => {
      if (data.success) {
        window.location.href = data.redirectUri;
      }
    },
    onError: (data: PauseSubscriptionResponse) => {
      window.location.href = data.redirectUri;
    },
  });
  return { mutate, mutateAsync, isLoading, isError };
}
